export default "__VITE_ASSET__DB72lPeD__"